<template>
  <div v-if="showDialog" class="modal fade show" tabindex="-1"
       style="display: block; background-color: rgba(0,0,0,0.5)"
       @click.self="handleCancel">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ title }}</h5>
          <button type="button" class="btn-close" @click="handleCancel"></button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label :for="inputId" class="form-label">{{ inputLabel }}</label>
            <input :id="inputId"
                   type="text"
                   ref="input"
                   :placeholder="placeholder"
                   class="form-control"
                   v-model="inputValue"
                   @input="validate"
                   @keyup.enter="handleOk"
                   @keyup.esc="handleCancel">
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="handleCancel">
            <i class="fas fa-times"></i> Cancel
          </button>
          <button type="button" class="btn btn-primary" @click="handleOk" :disabled="!isValid">
            <i class="fas fa-check"></i> OK
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let nextId = 0;
</script>

<script setup>
import {getCurrentInstance, nextTick, onMounted, ref, useTemplateRef, watch} from 'vue'
import {addIcon} from "@/plugins/fontawesome";
import {
  faCheck,
  faTimes
} from '@fortawesome/pro-solid-svg-icons';
import getId from "@/components/dialogs/UniqId";


addIcon(faCheck, faTimes);


// Generate unique ID for the input field
const inputId = `dialog-input-${getId()}`


// Input value state
const inputValue = ref("")
const showDialog = ref(false)
const title = ref("Input")
const inputLabel = ref("Provide input")
const input = useTemplateRef("input")

const closePromise = ref(false)
const placeholder = ref("")
const isValid = ref(false)
const errorMessage = ref("")

let validator = null;

// Reset input value when dialog opens
const setupDialog = (dialogTitle, dialogInputLabel, resultPromiseFunction, validatorFunction=null, dialogInputPlaceholder="") => {
  closePromise.value = resultPromiseFunction;
  title.value = dialogTitle;
  inputLabel.value = dialogInputLabel;
  placeholder.value = dialogInputPlaceholder;
  validator = validatorFunction;
  errorMessage.value = "";
  isValid.value = false;
  showDialog.value = true;
  inputValue.value = "";
  validate();
  nextTick(() => {
    input.value.focus();
  })
}

const validate = () => {
  if(!validator){
    isValid.value = true;
  }
  let validationResult = validator(inputValue.value);
  if(validationResult === true){
    isValid.value = true;
  } else {
    isValid.value = false;
    errorMessage.value = validationResult;
  }
}

// Handle OK button click
const handleOk = () => {
  if(isValid.value) {
    showDialog.value = false;
    if (closePromise.value) {
      closePromise.value(inputValue.value);
      closePromise.value = false;
    }
  }
}

// Handle Cancel button click
const handleCancel = () => {
  showDialog.value = false;
  if(closePromise.value) {
    closePromise.value(undefined);
    closePromise.value = false;
  }
}

// Handle ESC key
if (typeof window !== 'undefined') {
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && showDialog) {
      handleCancel()
    }
  })
}

defineExpose({
  setupDialog
})
</script>

<style scoped>
.modal.show {
  display: block;
}
</style>